(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/game-launcher-wrapper.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PlayAgain = svs.tickets.play.components.PlayAgain;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const {
  GameLauncherLeia,
  GameWrapper,
  TopBar,
  Receipt,
  LoaderTicket,
  TicketIdPopper
} = svs.ticketgames.ticketUtility.components;
const {
  resizeFromFullscreen,
  resizeFromTicketInfo,
  useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory,
  showDialog,
  tracking
} = svs.ticketgames.ticketUtility.utils;
const {
  useCustomEvents
} = svs.tickets.play.containers;
const {
  useEffect,
  useState,
  useCallback,
  useReducer,
  useMemo
} = React;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const GameLauncherWrapper = _ref => {
  var _ticketInfo$skins;
  let {
    appTimeline,
    demo: isDemo,
    hasUnscratchedTicket,
    history,
    onClose,
    skinId,
    ticketInfo,
    ticketNumber,
    wager,
    wagerId,
    gameIsCompleted,
    listener,
    test = false
  } = _ref;
  const [fullScreenMargin, setFullScreenMargin] = useState(false);
  const [wrapperSize, setWrapperSize] = useState({});
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const betId = wagerId && parseInt(wagerId, 10);
  const [state, dispatch] = useReducer(reducer, {
    isDemo,
    ticketInfo,
    wager,
    betId,
    isFullScreenGame
  });
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    isDemo,
    isReplay: gameIsCompleted,
    wagerId,
    onClose
  });
  const {
    onPlayAgain
  } = useCustomEvents({
    appTimeline,
    ticketInfo,
    isDemo,
    history,
    hasUnscratchedTicket,
    dispatch
  });
  const {
    isLoading,
    gameResult,
    shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage,
    soundStatus,
    notifySoundStatus
  } = useScratchDefaultEventsLeiaFactory({
    demo: isDemo,
    ticketInfo,
    isFullScreenGame,
    gameIsCompleted,
    onPlayAgain,
    hasUnscratchedTicket,
    onClose,
    test
  });
  const shouldShowReceipt = gameIsCompleted && !isLoading;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  useEffect(() => {
    const init = async () => {
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product,
        branding: product
      };
      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !isDemo) {
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs, _svs$setupExtraData;
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        }));
      }
      svs.tickets.play.utils.utils.hideFooter();
    };
    init();
    return () => {
      setTimeout(() => {
        var _appTimeline$isActive;
        if (!(appTimeline !== null && appTimeline !== void 0 && (_appTimeline$isActive = appTimeline.isActive) !== null && _appTimeline$isActive !== void 0 && _appTimeline$isActive.call(appTimeline))) {
          var _appTimeline$pause, _appTimeline$seek;
          appTimeline === null || appTimeline === void 0 || (_appTimeline$pause = appTimeline.pause) === null || _appTimeline$pause === void 0 || _appTimeline$pause.call(appTimeline);
          appTimeline === null || appTimeline === void 0 || (_appTimeline$seek = appTimeline.seek) === null || _appTimeline$seek === void 0 || _appTimeline$seek.call(appTimeline, 'gameReady');
        }
      }, 0);
      svs.tickets.play.utils.utils.showFooter();
      svs.tickets.play.utils.utils.showHeaders(true);
    };
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const bubbleWinOptions = _objectSpread({
    demo: isDemo,
    product: ticketInfo.type
  }, gameResult);
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    isDemo,
    location: wager ? 'mina-spel' : 'spela',
    gameCode: ticketInfo.type
  });
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const hasTicketNumber = Boolean(ticketNumber && typeof parseInt(ticketNumber, 10) === 'number' && ticketNumber < 32);
  const gameSpecificParameters = {
    skinId: !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) && skinId ? skinId : 1
  };
  const onDialogClose = () => {
    if (svs.tickets.data.validateTicket && !isDemo) {
      var _svs$tickets$data$val;
      tracking.trackValidateQualtrics({
        numberOfTicketsPurchased: 1,
        winAmountValidatedTicket: (_svs$tickets$data$val = svs.tickets.data.validateTicket) === null || _svs$tickets$data$val === void 0 ? void 0 : _svs$tickets$data$val.winAmount,
        winAmountNewTicket: (gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon) || (gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount)
      });
    }
    onClose();
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "js-game-launcher-wrapper ".concat(gameResult ? 'game-complete ' : '').concat(isFullScreenGame ? '' : "padding-top-2".concat(!wager ? ' padding-bottom-2' : ''))
  }, shouldShowBubbleWinMessage && !isFullScreenGame && React.createElement("div", {
    className: "qa-win-message-container game-header relative"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement(GameWrapper, {
    className: "".concat(isFullScreenGame ? '' : 'ticket-shadow'),
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      var _gameResult$amount;
      showDialog({
        type: 'close',
        isDemo,
        onClose: onDialogClose,
        trackingData: {
          label: topBarTrackingLabel,
          value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
        }
      });
    },
    onSoundClick: () => {
      notifySoundStatus(!soundStatus);
    },
    trackingLabel: topBarTrackingLabel
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    listener: listener,
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, {
    hasTicketNumber: hasTicketNumber
  }), isLoading && React.createElement(LoaderTicket, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image)
  }), !isLoading && hasTicketNumber && React.createElement("div", {
    className: "ticket-number absolute"
  }, ticketNumber))), React.createElement(Receipt, {
    fetchedGame: wager,
    show: shouldShowReceipt,
    ticketInfo: ticketInfo
  })), shouldShowPlayAgainFooter && React.createElement(PlayAgain, {
    handlePlayAgain: onPlayAgain,
    hasUnscratchedTicket: hasUnscratchedTicket,
    ticketInfo: ticketInfo
  }));
};
setGlobal('svs.tickets.play.containers.GameLauncherWrapper', GameLauncherWrapper);

 })(window);